export default __webpack_public_path__ + "images/4a311ef7f5afe76cbffb5310ff8de5ff-science.png";